import { api } from "@api"

export const handleGetChannelsWithMeta = async (userId: string) => {
  if (!userId) return []

  const { data, error } = await api().rpc('get_user_channels', { p_user_id: userId })

  if (error) throw error

  return data || []
}
